import React from 'react';
import "./PlanningFeatures.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";

class  PlanningFeatures extends React.Component {
    render () {
        return (
            <div>
                 <Nav/>
    <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/About">01 Master Plan</a></p>
              <p className="ab">Planning Structure</p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/PlanningFeatures">Planning Features</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Intro"> 02 Project Introduction</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/ProLoc">04 Project Location</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoVision">05 Eco-Vision</a></p>
            </div>
          </div>
        <div className="col-8">
        <div class="abhead5">
        <p></p>
        </div>
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>Planning Features</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}>At the Heart of the Global Circular Economy</p>
        <p className="text-justify">The Bamboo Eco-city is a collaboration project between the Central Region Development Commission of Ghana and Good Morning Bamboo Agro-Forestry and Investment Services (Good Morning Bamboo). As part of the collaboration, a master plan for sustainable living was jointly agreed to be developed based on experiences in Ghana and Singapore. The planning of each of the 5 districts in Good Morning Bamboo Eco-city are adapted from the Neighborhood Concept in Singapore and tailored to meet local needs and requirements. Eco-cells measuring about 400m x 400m form the basic building block of these Eco-Communities. The Eco-cells are designed based on the human experience of what is considered as comfortable walking distances. Each Eco-cell can accommodate some 2,500 dwelling units (DUs) with approximately 8,000 to 10,000 residents. But in a larger Eco-city, four Eco-cells form an Eco-Community with about 9,000 DUs and 30,000 residents. Four or more Eco-Communities will form a District.

</p>
        </div>
       
      
     </div>
   </div>
            </div>
        )
    }
}
export default withRouter(PlanningFeatures);